import React, {Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {CssBaseline, Typography, IconButton, Dialog,withStyles, Button} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import {isMobileOnly, CustomView} from 'react-device-detect';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import alertSound from './alert.mp3'

const textSize1 = () =>{
    if (isMobileOnly) return 'h5'
    else return 'h4'
  }
  
  const textSize2 = () =>{
    if (isMobileOnly) return 'h7'
    else return 'h7'
  }

 const buttonSize = () => {
   if (isMobileOnly) return 'small'
   else return 'medium'
 }

  const customWidth = (name) => {
    if (isMobileOnly) {
      if (name === 'time') return {minWidth: '30vw'}
      else if (name === 'address') return {minWidth: '36vw'}
    }
    else return {maxWidth: '10vw'}
  }

  const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    
  });

  const useCustomStyles = makeStyles({
  
      ContentBackground:{
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#282c34',
        height: '80vh',
        overflow: 'auto',
        display: 'flex',
        width:'100vw',
        textAlign: 'center',
        verticalAlign: 'middle',
        flexDirectison: 'columns',
      },

      containerStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        display: 'flex',
        textAlign: 'center',
        verticalAlign: 'middle',
        flexDirectison: 'columns',
      },
  
      title: {
        marginTop: '2vh',
        marginLeft: '2vw',
        color: 'black',
        display: 'flex',
        fontFamily:'Roboto',
        fontStyle: 'oblique',
        fontWeight: 'bold'
      },
  
  
      inputCenter: {
        textAlign: "center",
        color: "red"
      }
    });


const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default function ShipperView({fire, soundAudio}) {
  //localStorage.removeItem('autoLogin')
  const classes = useStyles();
  const styleClasses = useCustomStyles();
  const [userName,setName] = React.useState('');
  const [request, setRequest] = React.useState('')
  const [password,setPass] = React.useState('');
  const [isChecked, setCheck] = React.useState(true)
  const [tabView, setTab] = React.useState(0)
  const [dialogCont,setCont] = React.useState([])
  const [open,setOpen] = React.useState(false)
  const [openDialog,setDialog] = React.useState(false)
  const [isIn,setView] = React.useState(parseInt(localStorage.getItem('autoLogin')) || 0)

  const fillform = (field) => event => {
    event.preventDefault();
    if (field === 'username') setName(event.currentTarget.value);
    if (field === 'password') setPass(event.currentTarget.value);
  }

  const autoLogin = () => event => {
      event.preventDefault();
      setCheck(event.target.checked)
  }

  const logIn = () => event => {
    event.preventDefault(); 
    const dataRef = fire.database().ref('Shipper');
    dataRef.orderByChild('UserName').equalTo(userName).once('value',(snapshot) =>{
            let items = snapshot.val();
            for (let item in items) {
                if (items[item].Pass === password) {
                    if (isChecked) {
                      localStorage.setItem('autoLogin', 1); 
                    }
                    else localStorage.setItem('autoLogIn', 0)
                    localStorage.setItem('username', userName);
                    localStorage.setItem('password',password);
                    localStorage.setItem('sellerType',items[item].Type)
                    localStorage.setItem('shipperName', items[item].Name ); 
                    localStorage.setItem('ShipperPhoneNo', items[item].PhoneNo);
                    localStorage.setItem('shopInfo', JSON.stringify(items[item].DeliveryShop))
                    setView(1)
                }
                else {
                    setName('');
                    setPass('');
                }
            }
        })
  }


  function LogInView (){
    return(
        <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="email"
            autoFocus
            value = {userName}
            onChange = {fillform('username')}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            value = {password}
            onChange = {fillform('password')}
          />
          <FormControlLabel
            control={<Checkbox checked={isChecked} onChange = {autoLogin()} value="remember" color="primary" />}
            label="Remember me"
          />
          <Button
            onClick ={logIn()}
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In
          </Button>
        </form>
      </div>
    </Container>
    )
  }

  class OrderView extends Component  {
    constructor() {
      super();
      
    this.state = {
      container: [],
      filtercontainer: [],
      weekYears: [],
      active: -1,
    };
    }
    componentDidMount() {
      const UserName = localStorage.getItem('username') || ''
      const PassWord = localStorage.getItem('password') || ''
      let shop = JSON.parse(localStorage.getItem('shopInfo')) || []
      const shipperType = Number(localStorage.getItem('shipperType')) || 0
      const shipperRef = fire.database().ref('Shipper');
      const orderRef =  fire.database().ref('UserOrder');
    
    shipperRef.on('value',(snapshot) => {
      let children = snapshot.val();
      let foundShipper = false;
      for (let i in children) {
        if (children[i].Pass === PassWord && children[i].UserName === UserName) {
            localStorage.setItem('shipperType', children[i].Type);
            localStorage.setItem('shopInfo', JSON.stringify(children[i].DeliveryShop))
            localStorage.setItem('shipperIndex',i)
            foundShipper = true;
        }
      }
      if (!foundShipper) {
        setName('');
        setPass('');
        localStorage.removeItem('username');
        localStorage.removeItem('autoLogIn');
        setView(0)
      }
    })

    orderRef.on('value',(snapshot) => {
        let newState = [];
        let filterState = [];
        let items = snapshot.val();
            for (let item in items){
                for (let element in items[item].collect){
                  if (items[item]['collect'][element].collect !== 'Pick-up') {
                    for (let infors in shop) {
                          if ((shop[infors].Name === items[item]['collect'][element].name && shop[infors].Address === items[item]['collect'][element].address)
                          && ((!items[item]['order'][shop[infors].Name].Shipper) || items[item]['order'][shop[infors].Name].Shipper === localStorage.getItem('shipperName'))
                          && ( items[item]['order'][shop[infors].Name].status ==='Pending' 
                          ||  items[item]['order'][shop[infors].Name].status ==='Ready' 
                          || items[item]['order'][shop[infors].Name].status === 'Preparing'
                          || items[item]['order'][shop[infors].Name].status === 'On The Way' )) newState.push({
                            deliveryFee: items[item]['collect'][element].fee,
                            discount:  items[item]['order'][shop[infors].Name].Promo,
                            shopName: items[item]['collect'][element].name,
                            location: items[item].location,
                            customerName: items[item].name,
                            phoneNo: items[item].phoneNo,
                            orderTime: items[item].orderTime,
                            payment: items[item].payment,
                            order: items[item]['order'][shop[infors].Name],
                            address: shop[infors].Address
                          })

                          if ((shop[infors].Name === items[item]['collect'][element].name && shop[infors].Address ===  items[item]['collect'][element].address)
                          && items[item]['order'][shop[infors].Name].status === 'Completed'
                          && (items[item]['order'][shop[infors].Name].Shipper) 
                          && items[item]['order'][shop[infors].Name].Shipper === localStorage.getItem('shipperName')) filterState.push({
                            deliveryFee: items[item]['collect'][element].fee,
                            shopName: items[item]['collect'][element].name,
                            location: items[item].location,
                            customerName: items[item].name,
                            phoneNo: items[item].phoneNo,
                            orderTime: items[item].orderTime,
                            order: items[item]['order'][shop[infors].Name],
                            orderWeek: this.getWeekNumber(new Date(items[item].orderTime))[1],
                            orderYear: this.getWeekNumber(new Date (items[item].orderTime))[0]
                          })
                        
                    }
                  }
                } 
            }
        
            const groupByWeekYear = this.groupBy(['orderWeek','orderYear'])
            let stateByTime = groupByWeekYear(filterState)
            let weekYears = [];
            for (let weekYear in stateByTime) {
              delete stateByTime[weekYear].orderWeek;
              delete stateByTime[weekYear].orderYear;
    
              const subTotal = stateByTime[weekYear].reduce(function (s, a) { 
               return Number(s) + Number(a.deliveryFee) }, 
                0)
              let BimBimPay = 0;
              if ((shipperType) && shipperType === 1) BimBimPay = 0.5*subTotal; 
              weekYears.push({time: weekYear, subTotal: subTotal, BimBimPay: BimBimPay})
            }

            let active = this.state.active 

        if (newState.length > active && active !== -1) 
        {

          const pending = newState.reduce(function (s,a){
            if (a.order.status === 'Pending') return s + 1
            else return s},
            0)

          if ("serviceWorker" in navigator && "PushManager" in window) this.askForPermissionToReceiveNotifications(pending);
          else {
            soundAudio.src = alertSound
            soundAudio.play()
          }
        }

        this.setState({container: newState, filtercontainer: stateByTime, weekYears: weekYears, active: newState.length})
    });
    
  }

  askForPermissionToReceiveNotifications = async (pending) => {
    try {
      const messaging = fire.messaging();
      await messaging.requestPermission().then( () => {
        navigator.serviceWorker.getRegistration("https://bimbim-pwa.firebaseapp.com/firebase-messaging-sw.js").then((registration) => {
          const title = "BimBim"
          const options = {
            body : `You have new order. ${pending} orders are Pending`,
            icon : "https://bimbim-pwa.firebaseapp.com/bim192.png",
            requireInteraction: true 
          };
          registration.showNotification(title,options)
        });;
      });

     // return token;
    } catch(error) {console.error(error);}
  }

    getWeekNumber = (d) => {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
      // Get first day of year
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
      // Return array of year and week number
      return [d.getUTCFullYear(), weekNo];
    }

    groupBy = keys => array =>
      array.reduce((objectsByKeyValue, obj) => {
      const value = keys.map(key => obj[key]).join('-');
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      return objectsByKeyValue;
    }, []);

    handleClickOpen = (arg) => event => {
      event.preventDefault();
      const infor = JSON.parse(arg);
      setRequest(infor['request'])
      const maxValue = Object.keys(infor).length - this.minusNo(infor['Shipper'], infor);
      let newState = []
      for (let i = 0; i< maxValue; i++){
          newState.push(infor[i])
      }
      setCont(newState)
      setOpen(true)
    }

    minusNo = (arg1, arg2) => { 
      if ('Promo' in arg2) {
        if (arg1) return 7
        else return 5
      }
      else {
        if (arg1) return 6
        else return 4
      }
    }

    tabChange = (event, newValue) => {
      event.preventDefault();
      setTab(newValue);
    };

    buttonText = (arg) => {
      if (arg && arg === localStorage.getItem('shipperName')) return 'Received'
      else return 'Accept'
    }

    onAccept = (name,orderTime,shopName, command) => event => {
      event.preventDefault();
      const orderRef =  fire.database().ref('UserOrder');
      orderRef.orderByChild('name').equalTo(name).once('value',(snapshot) => {
        let items = snapshot.val();
        for (let item in items) if (items[item].orderTime === orderTime) {
          if (command === "Received") fire.database().ref(`UserOrder/${item}/order/${shopName}`).update({status: 'On The Way'})
          else {
          fire.database().ref(`UserOrder/${item}/order/${shopName}`).update({Shipper: localStorage.getItem('shipperName')})
          fire.database().ref(`UserOrder/${item}/order/${shopName}`).update({ShipperPhone: localStorage.getItem('ShipperPhoneNo')})
          }
        }
      })
    }

    onArrive = (contact, sender) => event => {
      event.preventDefault();
      if (isMobileOnly){
        if(navigator.userAgent.match(/Android/i)) {
          window.open(`sms:${contact}/?body=Your order from ${sender} has arrived. Please come out to pick up your order or contact if you can't find me`,'_blank')
        }
        
        if(navigator.userAgent.match(/iPhone/i)) {
          window.open(`sms:${contact}&body=Your order from ${sender} has arrived. Please come out to pick up your order or contact if you can't find me`,'_blank')
        }
      }

      else setDialog(true) 

    }

    onComplete = (name,orderTime,shopName) => event => {
      event.preventDefault();
      const orderRef =  fire.database().ref('UserOrder');
      orderRef.orderByChild('name').equalTo(name).once('value',(snapshot) => {
        let items = snapshot.val();
        for (let item in items) if (items[item].orderTime === orderTime) {
          fire.database().ref(`UserOrder/${item}/order/${shopName}`).update({status: 'Completed'})
        }
      })
    }

     handleClose = () => setOpen(false)

     closeDialog = () => setDialog(false)

     signOut = () => event => {
       event.preventDefault();
       setName('');
       setPass('');
       localStorage.removeItem('username');
       localStorage.removeItem('autoLogIn');
       setView(0)
     }

     a11yProps = (index) => {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }

  render() {
    return (
      <div >

      <AppBar position="static">
        <Tabs 
        value={tabView} 
        onChange={this.tabChange} 
        aria-label="simple tabs example" 
        centered>
          <Tab label="Orders" {...this.a11yProps(0)} />
          <Tab label="History" {...this.a11yProps(1)} />
        </Tabs>
      </AppBar>

      <p></p>
      <Button color = 'secondary' onClick = {this.signOut()} variant = 'contained'>Sign Out</Button>
      <CustomView condition = {tabView === 0}>
        <CustomView condition = {(this.state.container.length !== 0)}>
          <p></p>
        { this.state.container
        .sort(function(a,b){return (new Date(a['order'].timeCollect)-((new Date(b['order'].timeCollect))))})
        .map(items => (
        <div>
          <div style ={{backgroundColor: 'lightgray'}}>
            <Button 
              onClick = { event => {event.preventDefault(); window.open(`http://maps.google.com/?q=${items.address}`,"window name","location=yes,height=1000,width=1000,scrollbars=yes,status=yes,modal=yes,alwaysRaised=yes"); return false}} 
              color = 'inherit'
              >
               {items.shopName}
            </Button>
          </div>
          <TableContainer component={Paper}>
          <Table aria-label="simple table">
          <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell style = {customWidth()} align = 'center'>Address</TableCell>
            <TableCell  style = {customWidth()} align = 'center'>Time</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align='center'>
                <Button color = 'primary' onClick = {this.handleClickOpen(JSON.stringify(items['order']))}>Detail</Button>
            </TableCell>
            <TableCell align='center'>
                <Button disabled = {items['order'].status !== 'On The Way' || !(items['order'].Shipper) || items['order'].Shipper !== localStorage.getItem('shipperName')} 
                variant='contained'
                onClick= {this.onComplete(items.customerName, items.orderTime, items.shopName)}
                >
                Complete
                </Button>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            <TableRow key={items.customerName}>
            <TableCell>
              <Button 
              onClick = { event => {event.preventDefault(); if (isMobileOnly) window.open(`sms:${items.phoneNo}&body=`,'_blank'); return false}} 
              color = 'primary'
              size = {buttonSize()}
              >
              {items.customerName}
            </Button>
            </TableCell>
            <TableCell style = {customWidth('address')}>
              <Button 
              onClick = { event => {event.preventDefault(); window.open(`http://maps.google.com/?q=${items.location}`,"window name","location=yes,height=1000,width=1000,scrollbars=yes,status=yes,modal=yes,alwaysRaised=yes"); return false}} 
              color = 'primary'
              size = {buttonSize()}
              fullWidth = {true}
              >
               {items.location}
              </Button>
            </TableCell>
            <TableCell  style = {customWidth('time')}>
                {(new Date(items['order'].timeCollect)).toLocaleString()}
            </TableCell>
            <TableCell align="center">
              <Typography>
                {items['order'].status} / {items.payment}  
              </Typography>
            </TableCell>
            <TableCell align="right">
                {(Number(items.deliveryFee) + Number(items['order'].shopTotal) - Number(items.discount)).toFixed(2)}
            </TableCell>
            <TableCell align= 'center'>
            <Button disabled = {items['order'].status !== 'On The Way'} 
                variant='contained' 
                color = 'secondary'
                onClick = {this.onArrive(items.phoneNo, items.shopName)}
                >
                  Arrive
            </Button>
            </TableCell>
            <TableCell align='center'>
                <Button disabled = {items['order'].status === 'Pending' || items['order'].status === 'On The Way' || ((items['order'].Shipper) && items['order'].Shipper !== localStorage.getItem('shipperName'))} 
                variant='contained' 
                color = 'secondary'
                onClick = {this.onAccept(items.customerName, items.orderTime, items.shopName, this.buttonText(items['order'].Shipper))}
                >
                  {this.buttonText(items['order'].Shipper)}
                </Button>
            </TableCell>
            </TableRow>
         </TableBody>
      </Table>
    </TableContainer>
    <p></p>
    </div>
    ))}
    </CustomView>
      
    <CustomView condition = {(this.state.container.length === 0)} >
        <div className = {styleClasses.containerStyle}>
            <Typography variant={textSize1()}>
                You have no order at the moment
            </Typography>
        </div>
    </CustomView>

  </CustomView>

  <CustomView condition = {tabView === 1}>
    <CustomView condition = {(this.state.weekYears.length !== 0)}>
      <p></p>

        { this.state.weekYears.reverse().map(weekYear => (
        <div>
          <div style ={{backgroundColor: 'lightgray'}}>
            <Typography className={styleClasses.title} variant= {textSize2()} noWrap>
                Week {weekYear.time}
            </Typography>
          </div>
          <TableContainer component={Paper}>
          <Table aria-label="simple table">
          <TableHead>
          <TableRow>
            <TableCell>Shop</TableCell>
            <TableCell  style = {customWidth()}>Time</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.filtercontainer[weekYear.time].reverse().map(items => 
            <TableRow key={items.customerName + items.orderTime}>

            <TableCell>
                {items.shopName}
            </TableCell>

            <TableCell  style = {customWidth('time')}>
                {(new Date(items['order'].timeCollect)).toLocaleString()}
            </TableCell>
            
            <TableCell align="right">
                {Number(items.deliveryFee).toFixed(2)}
            </TableCell>

            <TableCell align= 'center'>
              <Typography style = {{fontStyle: 'bold'}}>
              {items.collect}
              </Typography>
            </TableCell>

            <TableCell align='center'>
                <Button color = 'primary' onClick = {this.handleClickOpen(JSON.stringify(items['order']))}>Detail</Button>
            </TableCell>
            
            </TableRow>
          )}
            <TableRow>
            <TableCell />
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                Subtotal:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography style={{color: 'goldenrod', fontWeight: 'bold'}}>
                {Number(weekYear.subTotal).toFixed(2)}
            </Typography>
            </TableCell>
            <TableCell colSpan= {2}/>
          </TableRow>

          <TableRow>
            <TableCell />
    
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                BimBim Pay:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography style={{color: 'red', fontWeight: 'bold'}}>
                {(Number(weekYear.BimBimPay)).toFixed(2)}
            </Typography>
            </TableCell>
            <TableCell colSpan= {2}/>
          </TableRow>
        
          <TableRow>
            <TableCell />
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                Total:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography style={{color: 'goldenrod', fontWeight: 'bold'}}>
                {(Number(weekYear.subTotal)+ Number(weekYear.BimBimPay)).toFixed(2)}
            </Typography>
            </TableCell>
            <TableCell colSpan= {2}/>
          </TableRow>
         </TableBody>
    </Table>
    </TableContainer>
    <p></p>
    </div>
    ))}

    </CustomView>

    <CustomView condition = {(this.state.weekYears.length === 0)} >
      <div className = {styleClasses.containerStyle}>
        <Typography variant={textSize1()}>
            You have no order history
        </Typography>
      </div>
    </CustomView>   
  </CustomView>
    
  <Dialog fullScreen={isMobileOnly} onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={open}>
    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}></DialogTitle>
      <DialogContent >
          <TableContainer component={Paper}>
                <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Snack</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    <TableCell align="right">Subtotal</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {dialogCont.map(item => (
            <TableRow key={item.Name} style={{ overflow: 'auto'}}>
            <TableCell>
                <img style ={{height: '8vh'}} src = {item.ImageLink} alt = {item.Name}/>
            </TableCell>
            <TableCell >
                {item.Name}
            </TableCell>
            <TableCell align="center">
                {item.Amount}
            </TableCell>
              <TableCell  align="right">
              <Typography>
                ${Number(item.Total).toFixed(2)}
                </Typography>
              </TableCell>
            </TableRow>
            ))}
                </TableBody>
                </Table>
          </TableContainer>
            <p></p>
            <Typography>
                Request: {request}
              </Typography>
        </DialogContent>
    </Dialog>

    <Dialog fullWidth ='true' maxWidth = 'sm' onClose={this.closeDialog} aria-labelledby="customized-dialog-title" open={openDialog}>
      <DialogTitle id="customized-dialog-title" onClose={this.closeDialog}>Mobile Required</DialogTitle>
        <DialogContent >
          <Typography>
              SMS Notification is required to inform customers. Please log in with your mobile device
          </Typography>
        </DialogContent>
    </Dialog>

    <CssBaseline/>
    </div>
    )}
  }

  function renderView () {
      switch(isIn) {
      case 0: return LogInView();
      case 1: return <OrderView/>;
      default: return false;
    }
  }

  return (renderView());
}